export class CommessaSearchModel {
  client_name?: string = "";
  number?: string = "";
  createdAt?: Date = undefined;
  matricola?: string = "";
  state?: string = "";
}
